export const size = {
  small: '1280',
  medium: '1366',
  large: '1536',
  extraLarge: '1920'
};

export const heightPixel = {
  small: '720px'
};

export const sizePixle = {
  small: '1280px',
  medium: '1366px',
  large: '1536px',
  extraLarge: '1920px'
};

// gte stands for 'greater than or equal', lte stands for 'lower than or equal'
export const monitor = {
  lte_small_height: `(max-height: ${heightPixel.small})`,
  lte_small: `(max-width: ${sizePixle.small})`,
  lte_medium: `(max-width: ${sizePixle.medium})`,
  lte_large: `(max-width: ${sizePixle.large})`,
  lte_extraLarge: `(max-width: ${sizePixle.extraLarge})`,
  gte_small: `(min-width: ${sizePixle.small})`,
  gte_medium: `(min-width: ${sizePixle.medium})`,
  gte_large: `(min-width: ${sizePixle.large})`,
  gte_extraLarge: `(min-width: ${sizePixle.extraLarge})`
};

export const customSizesPx = {
  cs_1660: 1660
};

/** Used for Old screen which didnt get any resolution definitions.. it is used to make current design to look as good as possible * */
export const customSizes = {
  cs_1560: 1560,
  cs_1616: 1616
};
